import { render } from "./InspectionPlanResultDetail.vue?vue&type=template&id=74b8b989"
import script from "./InspectionPlanResultDetail.vue?vue&type=script&lang=js"
export * from "./InspectionPlanResultDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__